import * as React from "react";
import styled from "styled-components";
import { Row, Col } from "antd";
import { ReactComponent as IconCheck } from "../../../assets/icons/icon_check.svg";

const Label = styled.span`
  font-size: 11px;
  font-weight: 300;
  color: #061a32;
`;

const CheckedSquare = styled(IconCheck)`
  width: 21px;
  height: 21px;
  padding: 3px;
  border-radius: 4px;
  border: solid 0.5px #dedede;
  background-color: #f2f2f2;
`;

type Props = {
  title: string;
  key: string;
};

export const SelectedExtraRow: React.FC<Props> = props => {
  return (
    <Row style={{margin: "10px 0"}} key={props.key}>
      <Col span={3}>
        <CheckedSquare />
      </Col>
      <Col span={21}>
        <Label>{props.title}</Label>
      </Col>
    </Row>
  );
};
